<template>
  <div class="ui form">
    <!-- <h4 class="ui dividing header">{{ $t("currency") }}</h4> -->
    <div class="two fields">
      <div class="field">
        <label for="">{{ $t("currency") }} </label>
        <select
          class="ui selection dropdown"
          ref="currency_dropdown"
          v-model="settings.currency_iso"
        >
          <option value="GTQ">{{ $t("guatemalan quetzal") }}</option>
          <option value="USD">{{ $t("united states dollar") }}</option>
          <option value="EUR">{{ $t("euro") }}</option>
        </select>
      </div>
      <div class="field">
        <label for="">{{ $t("symbol") }} </label>
        <input type="text" name="currency" v-model="settings.currency" />
      </div>
    </div>
  </div>
</template>

<script>
import currency from "@/currency";

export default {
  name: "CurrencyManagement",
  components: {},
  computed: {},
  props: { settings: Object },
  data() {
    return {};
  },
  methods: {},
  created() {},
  mounted() {
    let vm = this;

    window.jQuery(vm.$refs.currency_dropdown).dropdown();
    // }, 200);
  },
  watch: {
    "settings.currency_iso"(newVal) {
      let trgt = currency[newVal];
      if (trgt)
        this.settings.currency = trgt.symbol_native || trgt.symbol || "?";
      else this.settings.currency = "¿";
    },
  },
  updated: function() {
    this.$nextTick(function() {
      window.jQuery(".ui.dropdown").dropdown();
    });
  },
};
</script>
